import { buttonVariants } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function DemoCta() {
  return (
    <section
      id="demo"
      className="relative py-20 lg:py-28 overflow-hidden bg-gradient-to-r from-brand-navy via-brand-navy-light to-brand-navy animate-gradient scroll-mt-16"
    >
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-red/15 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-navy-light/30 rounded-full blur-3xl" />

      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Ready to Transform Your Clinical Documentation?
        </h2>
        <p className="text-lg sm:text-xl text-white/80 mb-10 leading-relaxed max-w-2xl mx-auto">
          See how ConsultNow can save your providers 2+ hours per day. Schedule
          a personalized demo with our team.
        </p>
        <a
          href="mailto:demo@consultnow.com"
          className={cn(
            buttonVariants({ size: "lg" }),
            "bg-brand-red hover:bg-brand-red-dark text-white font-semibold shadow-lg shadow-brand-red/30 text-base px-8 h-12"
          )}
        >
          Request a Demo <ArrowRight className="ml-2 h-4 w-4" />
        </a>
      </div>
    </section>
  );
}
